import React from 'react';
import styles from './styles.scss';
import type FootnoteModel from 'Stores/FootnoteModel';
import { FootnoteModelType } from 'Stores/FootnoteModel';
import PropTypes from 'prop-types';

const FootnoteList = ({ footnotes }) => {
  return footnotes.map((note: FootnoteModel, i: number) => {
    let indicator: number | string = note.number || i + 1;

    if (note.isGeneric && !note.number) {
      indicator = '';
    }

    const noteText = note.text.replace(/^<p>/i, `<p><span class="sr-only">Fußnote${indicator ? ' ' + indicator : ''}:</span> `);

    return (
      <div
        key={note.refId}
        className={styles.footnote}
        id={`footnote-ref-${note.refId}`}
      >
        <sup aria-hidden={true}>{indicator}</sup>
        <div dangerouslySetInnerHTML={{ __html: noteText }} />
      </div>
    );
  });
}

FootnoteList.propTypes = {
  footnotes: PropTypes.arrayOf(PropTypes.shape(FootnoteModelType))
}

export default FootnoteList;
